<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-module-submodule-select
              :pageId="pageId"
              :selectedMd="selectedCodeValue.moduleCode"
              :selectedSmd="selectedCodeValue.subModuleCode"
              :defaultMdOption="'select'"
              :defaultSmdOption="'select'"
              class="dp_flex"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_IF_ID')"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ prefix }}
            </div>
            <div class="comp_spacing" />
            <sui-text-field
              ref="interfaceId"
              v-model.trim="interfaceId"
              maxlength="96"
              @keyup="onKeyUpInput"
            />
            <div class="comp_spacing" />
            <sui-button
              v-permission:read="pageId"
              type="button"
              class="comm_btn_duplicate"
              :disabled="idCheckFlag"
              @click="onIdCheckClick"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_IF_NM')"
              :required="true"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              ref="interfaceName"
              v-model.trim="interfaceData.interfaceName"
              maxlength="25"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TRMT_TYPE')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              :selected="selectedCodeValue.interfaceTransmitTypeCode"
              :pageId="pageId"
              codeId="COD_IF_TRMT_TYPE"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CONN_SYS_NM')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model.trim="interfaceData.interfaceConnectionSystemName"
              maxlength="25"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CONN_ID')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model.trim="interfaceData.interfaceConnectionId"
              maxlength="100"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEND_SYS_NM')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model.trim="interfaceData.interfaceSendSystemName"
              maxlength="25"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RECP_SYS_NM')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model.trim="interfaceData.interfaceReceiptSystemName"
              maxlength="25"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PRG_NM')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <cmp-program-select
              :selectedPrg="selectedPrg"
              :readonly="true"
              @selected="onSelectedPrg"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PROC_TYPE')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              :selected="selectedCodeValue.interfaceProcessTypeCode"
              :pageId="pageId"
              codeId="COD_IF_PROC_TYPE"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CONN_WAY')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <!-- <sui-text-field
              v-model.trim="interfaceData.interfaceWayName"
              maxlength="30"
            /> -->
            <sui-code-select
              ref="selectInterfaceWayName"
              :selected="selectedCodeValue.interfaceWayName"
              :pageId="pageId"
              codeId="COD_IF_CONN_TYPE"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DIV')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              :selected="selectedCodeValue.interfaceDivisionCode"
              :pageId="pageId"
              codeId="COD_IF_DIV"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CMNC_TYPE')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              :selected="selectedCodeValue.interfaceCommunicationTypeCode"
              :pageId="pageId"
              codeId="COD_IF_CMNC_TYPE"
              :initialSelectedIndex="0"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_DATA_FMT')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              :selected="selectedCodeValue.interfaceDataFormatCode"
              :pageId="pageId"
              codeId="COD_IF_DATA_FMT"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CYCL')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model.trim="interfaceData.interfaceCycleContent"
              maxlength="100"
              class="width100"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_HIS_MGT_YN')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-radio
              v-model="interfaceData.interfaceHistoryManagementYn"
              value="Y"
            >
              Yes
            </sui-radio>
            <sui-radio
              v-model="interfaceData.interfaceHistoryManagementYn"
              value="N"
            >
              No
            </sui-radio>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CNTN')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <textarea
              v-model.trim="interfaceData.interfaceContent"
              rows="5"
              maxlength="1000"
              class="width100"
            />
          </div>
        </div>
      </div>
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:read="this.$options.name"
          type="button"
          class="comm_btn_border"
          @click="onNewAndCancelClick"
        >
          {{ $t('MSG_BTN_CANCEL') }}
        </sui-button>
        <sui-button
          v-permission:create="pageId"
          type="button"
          class="comm_btn_solid"
          @click="onSaveClick"
        >
          {{ $t('MSG_BTN_SAVE') }}
        </sui-button>
      </div>
    </div>
  </div>
</template>
<script>
// import - libraries (node modules)
// import - local files (js, vue, ...)
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMS_00002_P01', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    pageId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedCodeValue: {
        moduleCode: {
          label: '',
          key: '',
        },
        subModuleCode: {
          label: '',
          key: '',
        },
        interfaceTransmitTypeCode: {
          label: '',
          key: '',
        },
        interfaceProcessTypeCode: {
          label: '',
          key: '',
        },
        interfaceWayName: {
          label: '',
          key: '',
        },
        interfaceDivisionCode: {
          label: '',
          key: '',
        },
        interfaceCommunicationTypeCode: {
          label: '',
          key: '',
        },
        interfaceDataFormatCode: {
          label: '',
          key: '',
        },
      },
      interfaceData: {
        interfaceId: '',
        interfaceName: '',
        interfaceConnectionSystemName: '',
        interfaceConnectionId: '',
        interfaceSendSystemName: '',
        interfaceReceiptSystemName: '',
        interfaceProgramId: '',
        interfaceCycleContent: '',
        interfaceContent: '',
        interfaceHistoryManagementYn: 'N',
      },
      oldText: '',
      idCheckFlag: false,
      programFlag: false,
      selectedPrg: {
        programName: '',
        programId: '',
      },
      prefix: 'INF_',
      interfaceId: '',
    };
  },
  methods: {
    onKeyUpInput() {
      const newText = this.interfaceId;

      if (!utils.isEmpty(newText) && !utils.isEngNum_(newText)) {
        utils.messageBox('warning', this.$t('MSG_ALT_ONLY_ENGLISH_NUMBER_UNDERBAR'), null, () => {
          this.interfaceId = this.oldText;
        });
      } else {
        this.oldText = newText;
        this.idCheckFlag = false;
      }
    },
    onNewAndCancelClick() {
      this.$emit('onNewAndCancelClick');
    },
    onSelectedPrg() {
      this.programFlag = true;
      this.interfaceData.interfaceProgramId = this.selectedPrg.programId;
    },
    onIdCheckClick() {
      if (!utils.isEmpty(this.interfaceId)) {
        const interfaceId = `${this.prefix}${this.interfaceId}`;
        http.request(this.pageId, 'DTS_CMS_00006', {
          query: { interfaceId },
        }).then(res => {
          if (!res.data) {
            // 사용가능
            utils.messageBox('success', this.$t('MSG_ALT_USE_PSBL_ID'), null, () => {
              this.idCheckFlag = true;
              this.interfaceData.interfaceId = interfaceId;
            });
          } else {
            utils.messageBox('error', this.$t('MSG_ALT_DUPLICATE_ID'), null, () => {
              this.idCheckFlag = false;
              this.interfaceData.interfaceId = '';
            });
          }
        }).catch(error => {
          console.log(error);
        });
      } else {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_IF_ID')));
      }
    },
    getSaveData() {
      const data = {};
      utils.forEach(this.selectedCodeValue, (value, key) => {
        data[key] = value.key;
      });
      utils.assign(data, this.interfaceData);
      return data;
    },
    onSaveClick() {
      const saveData = this.getSaveData();
      const result = this.validation(saveData);
      if (result.valid) {
        this.saveAction(saveData);
      } else {
        utils.messageBox('warning', result.message, null, () => {
          if (!utils.isEmpty(result.focus)) {
            this.$refs[result.focus].setFocus();
          }
        });
      }
    },
    validation(data) {
      const result = {
        valid: true,
        message: '',
        focus: '',
      };
      utils.forEach(data, (value, key) => {
        if (utils.isEmpty(utils.trim(value))) {
          result.valid = false;
          switch (key) {
            case 'moduleCode':
              result.message = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_MDLE'));
              return false;
            case 'subModuleCode':
              result.message = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_SMDLE'));
              return false;
            case 'interfaceId':
              if (utils.isEmpty(this.interfaceId)) {
                result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_IF_ID'));
              } else {
                result.message = this.$t('MSG_ALT_SELT_DPCT_CHK');
              }
              result.focus = key;
              return false;
            case 'interfaceName':
              result.focus = key;
              result.message = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_IF_NM'));
              return false;
            // case 'interfaceTransmitTypeCode':
            //   this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_TRMT_TYPE'));
            //   return false;
            // case 'interfaceConnectionSystemName':
            //   this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_CONN_SYS_NM'));
            //   return false;
            // case 'interfaceConnectionId':
            //   this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_CONN_ID'));
            //   return false;
            // case 'interfaceSendSystemName':
            //   this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_SEND_SYS_NM'));
            //   return false;
            // case 'interfaceReceiptSystemName':
            //   this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_RECP_SYS_NM'));
            //   return false;
            // case 'interfaceProgramId':
            //   this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_PRG_ID'));
            //   return false;
            // case 'interfaceProcessTypeCode':
            //   this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_PROC_TYPE'));
            //   return false;
            // case 'interfaceWayName':
            //   this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_CONN_WAY'));
            //   return false;
            // case 'interfaceDivisionCode':
            //   this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_DIV'));
            //   return false;
            // case 'interfaceCommunicationTypeCode':
            //   this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_CMNC_TYPE'));
            //   return false;
            // case 'interfaceDataFormatCode':
            //   this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_SELECT'), this.$t('MSG_TXT_DATA_FMT'));
            //   return false;
            // case 'interfaceCycleContent':
            //   this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_CYCL'));
            //   return false;
            // case 'interfaceContent':
            //   this.validMessage = utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_CNTN'));
            //   return false;
            default:
              result.valid = true;
              result.message = '';
          }
        } else if (utils.isEqual(key, 'interfaceId')) {
          if (!this.idCheckFlag) {
            result.valid = false;
            result.focus = key;
            result.message = this.$t('MSG_ALT_SELT_DPCT_CHK');
            return false;
          }
        }
        return null;
      });
      return result;
    },
    saveAction(saveData) {
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, 'DTS_CMS_00003', {
          data: saveData,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, this.research);
        }).catch(error => {
          console.log(error);
        });
      });
    },
    research() {
      this.$emit('research');
    },
  },
};
</script>
<style scoped>
</style>
